import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { translate } from 'react-i18next'

const OrderSelection = ({ t, onSelected }) => {
  const { Option } = Select;

  return (
    <Select
      placeholder={t('my_record.sortby_select')}
      style={{ width: '100%' }}
      onChange={onSelected}>
      <Option value='create_date:asc'>{t('my_record.sortby_old_to_new')}</Option>
      <Option value='create_date:desc'>{t('my_record.sortby_new_to_old')}</Option>
      <Option value='file_size.reference:asc'>{t('my_record.sortby_small_to_large')}</Option>
      <Option value='file_size.reference:desc'>{t('my_record.sortby_large_to_small')}</Option>
      <Option value='file_name:asc'>{t('my_record.sortby_a_to_z')}</Option>
      <Option value='file_name:desc'>{t('my_record.sortby_z_to_a')}</Option>
    </Select>
  )
}

OrderSelection.propTypes = {
  onSelected: PropTypes.func.isRequired
}

export default translate()(OrderSelection)
